export const barcharColor = [
  "#fc8132",
  "#767778",
  "#d4476c",
  "#e87932",
  "#eea032",
  "#8cbf66",
];

export const defaultTickCount = 11;
